import React, { useEffect } from 'react'
import Section from 'gatsby-theme-leshen/src/components/Section'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { graphql, useStaticQuery } from 'gatsby'
import * as Styled from './Enrollment.styles'

function getNgIndex(file) {
  const ngOrder = {
    inline: 1,
    polyfills: 2,
    scripts: 3,
    main: 4,
  }

  const split = file.split('.')
  return (split.length && ngOrder[split[0]]) || Infinity
}

/**
 * force the angular app's bundle files to be included in the correct order (inline, polyfills, scripts, main)
 * @param gqlData
 * @returns {*}
 */
function orderNgFiles(gqlData) {
  const ngFiles = gqlData.allFile.edges.map(e => e.node.relativePath)
  ngFiles.sort((a, b) => getNgIndex(a) - getNgIndex(b))
  return ngFiles
}

const Enrollment = ({ className, basePath }) => {
  const data = useStaticQuery(graphql`
    query {
      allFile(
        filter: {
          sourceInstanceName: { eq: "enrollment-files" }
          relativePath: { regex: "/bundle.js$/" }
        }
      ) {
        edges {
          node {
            relativePath
          }
        }
      }
    }
  `)

  useEffect(() => {
    const interval = setInterval(() => {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'gatsby-route-change',
        })
        clearInterval(interval)
      }
    }, 1000)
  }, [])

  return (
    <>
      <Helmet>
        <meta charset="utf-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta
          name="viewport"
          content="width=device-width,initial-scale=1,shrink-to-fit=no"
        />
        <meta name="format-detection" content="telephone=no" />
        <div
          id="ZN_3lV988v08JVmixv"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: `<!--DO NOT REMOVE-CONTENTS PLACED HERE-->`,
          }}
        />
        <base href={basePath} />
      </Helmet>
      <Section heading="Enrollment" className={`enrollment-app ${className}`}>
        <Styled.Enrollment
          dangerouslySetInnerHTML={{
            __html: `
          <script src="https://jedevfilestorage01.blob.core.windows.net/devd/theme/js/app.bundle.js" type="text/javascript" defer="defer"></script>
          <link rel="stylesheet" href="/assets/css/enrollment.css" />
          <script>window.__theme = 'bs4';</script>
          <app-root></app-root>
        `,
          }}
        />
      </Section>
      {orderNgFiles(data).map(file => <script type="text/javascript" src={`/${file}`} />)}
    </>
  )
}

Enrollment.defaultProps = {
  className: '',
  basePath: '/',
}

Enrollment.propTypes = {
  className: PropTypes.string,
  basePath: PropTypes.string,
}

export default Enrollment
